import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';

const SingleExpenseDetails = () => {
  const { expenseId } = useParams();
  const decodedId = expenseId ? atob(expenseId) : expenseId;
  const id = decodedId.replace(/\D/g, '');  // Ensure we only get the numeric part
  const [expenseDetails, setExpenseDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {
    const fetchExpenseDetails = async () => {
      try {
        const response = await axios.get(`${API_DOMAIN}${API_ROUTES.expense}${id}/`, { headers });
        const extractedColumns = Object.keys(response.data);

        const paidFromAccountId = response.data.paid_from;
        //console.log(paidFromAccountId)
        if (paidFromAccountId) {
          const paidFromResponse = await axios.get(`${API_DOMAIN}${API_ROUTES.account}${paidFromAccountId}/`, { headers });
          const paidFromAccountDetails = paidFromResponse.data;          
          extractedColumns.push('Paid From Account Name');          
          response.data['Paid From Account Name'] = paidFromAccountDetails.name; 
         
        } 
      
      // Define which columns to exclude (if necessary)
        const excludedColumns = ['id', 'created_at', 'updated_at', 'paid_from'];
        const columnsArray = extractedColumns
          .filter((column) => !excludedColumns.includes(column))
          .map((column) => ({
            label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
            field: column,
          }));

        setColumnDetails(columnsArray);
        setExpenseDetails(response.data);
      } catch (error) {
        console.error('Error fetching expense details:', error);
      }
    };

    fetchExpenseDetails();
  }, [expenseId]);
  

  return (
    <div>
      {expenseDetails ? (
        <SingleItemDetailTemplate details={expenseDetails} columns={columns} />
      ) : (
        <p>Loading expense details...</p>
      )}
    </div>
  );
};

export default SingleExpenseDetails;